import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'

export function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState(0)
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      // Web : utiliser visualViewport API (Safari iOS, Chrome Android)
      const handleResize = () => {
        if (window.visualViewport) {
          const heightDiff = window.innerHeight - window.visualViewport.height
          setKeyboardHeight(heightDiff > 100 ? heightDiff : 0)
          setIsKeyboardOpen(heightDiff > 100)
        }
      }

      window.visualViewport?.addEventListener('resize', handleResize)
      return () => window.visualViewport?.removeEventListener('resize', handleResize)
    }

    // Native iOS/Android — import dynamique pour éviter les erreurs web
    let showRemover: (() => void) | null = null
    let hideRemover: (() => void) | null = null

    ;(async () => {
      try {
        const { Keyboard } = await import('@capacitor/keyboard')

        const showHandle = await Keyboard.addListener('keyboardWillShow', (info) => {
          setKeyboardHeight(info.keyboardHeight)
          setIsKeyboardOpen(true)
          document.body.classList.add('has-keyboard-open')
        })

        const hideHandle = await Keyboard.addListener('keyboardWillHide', () => {
          setKeyboardHeight(0)
          setIsKeyboardOpen(false)
          document.body.classList.remove('has-keyboard-open')
        })

        showRemover = () => showHandle.remove()
        hideRemover = () => hideHandle.remove()
      } catch {
        // @capacitor/keyboard non disponible
      }
    })()

    return () => {
      showRemover?.()
      hideRemover?.()
      document.body.classList.remove('has-keyboard-open')
    }
  }, [])

  return { keyboardHeight, isKeyboardOpen }
}
